<template>
  <div class="sf-grid sf-below-4">
    <div class="sf-row sf-row-center">
      <div class="sf-col sf-xs-12 sf-sm-8">
        <div
          class="sf-btn sf-block sf-pad-0 sf-below-3 sf-c-text sf-font-normal"
        >
          <div class="sf-level sf-level-bar">
            <div
              class="
                sf-level-item sf-pad-3 sf-level-item-full sf-overflow-hidden
              "
            >
              <div
                class="
                  sf-title
                  sf-font-l
                  sf-pad-1
                  sf-align-c
                  sf-truncate
                  sf-overflow-hidden
                "
              >
                Progression
                <span :v-if="hasRemaining"
                  >({{ remaining }} remaining periods)</span
                >
              </div>
              <div :class="cssProgressClass">
                <div
                  class="sf-progress-complete sf-bg-primary"
                  :style="cssProgressStyle"
                >
                  &nbsp;{{ progress }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
const LockLedgerProgressModal = {
  props: {
    channelName: {
      type: String,
      required: true,
    },
    lastChannelId: {
      type: Number,
      required: true,
    },

    initialProgress: {
      type: Number,
      required: true,
    },

    initialRemainingCount: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      progress: 0,
      remaining: null,
    }
  },

  computed: {
    cssProgressStyle() {
      return `width: ${this.progress}%`
    },

    cssProgressClass() {
      const classes = ['sf-progress', 'sf-bg-snow']
      if (this.progress < 100) {
        classes.push('sf-progress-animate')
      }
      return classes.join(' ')
    },

    hasRemaining() {
      return Boolean(this.remaining)
    },
  },

  created() {
    this.subscribe(this.channelName, this.lastChannelId)
    this.progress = this.initialProgress
    this.remaining = this.initialRemainingCount
  },

  beforeUnmount() {
    this.unsubscribe(this.channelName)
  },

  methods: {
    subscribe(channelName, lastChannelId) {
      window.Silverfin.Polling.subscribe(
        channelName,
        this.processed,
        lastChannelId
      )
    },

    unsubscribe(channelName) {
      window.Silverfin.Polling.unsubscribe(channelName, this.processed)
    },

    processed(data) {
      this.progress = data.progress
      this.remaining = data.remaining

      if (!this.remaining) {
        this.unsubscribe(this.channelName)
      }
    },
  },
}

export default LockLedgerProgressModal
</script>
